export default "__VITE_ASSET__96bde4b1__"